import * as z from "zod";

export const getCurrentUserRole = {
  name: "getCurrentUserRole" as const,
  input: z.object({}),
  output: z.object({ emailAddress: z.string(), adminServerRole: z.string() }),
};
